import { render, staticRenderFns } from "./BannerRecipe.vue?vue&type=template&id=6fc60e6b&scoped=true"
import script from "./BannerRecipe.vue?vue&type=script&lang=js"
export * from "./BannerRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc60e6b",
  null
  
)

export default component.exports